module.exports = __webpack_public_path__ + "f0ea5fe74540d312c5a52c367f2d2c33.png";


//////////////////
// WEBPACK FOOTER
// ./ts/components/images/logogray.png
// module id = 317
// module chunks = 0